export default __webpack_public_path__ + "static/media/summary_video.52156633.mp4";